import { Fexios } from '@jojotique/fexios'

export const fexios = new Fexios({
  baseUrl: import.meta.env.VITE_BACK,
})
